import { createContext, useContext } from "react";

import moment from "moment-timezone";

import { getOrganization, Organization } from "../utils/getOrganization";

const OrganizationContext = createContext<Organization>({} as Organization);

export const useOrganization = () => useContext(OrganizationContext);

export const OrganizationProvider = ({ children }: { children: React.ReactNode }) => {
  const organization = getOrganization();

  moment.tz.setDefault(organization.configuration.timezone);

  return <OrganizationContext.Provider value={organization}>{children}</OrganizationContext.Provider>;
};
